// usePlayerConfig.js
import playerConfigStore from "../store/playerConfigs";

// Custom hook để sử dụng và cập nhật cấu hình player
const usePlayerConfig = (playerId) => {
    const playerConfigs = playerConfigStore((state) => state.playerConfigs);
    const updateSingleConfig = playerConfigStore((state) => state.updateSingleConfig);
    const updatePlayerConfig = playerConfigStore((state) => state.updatePlayerConfig);
    const updateMultiplePlayersConfig = playerConfigStore((state) => state.updateMultiplePlayers);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        configs: playerId == null ? {} : playerConfigs[playerId] || {}, // Nếu không có playerId, trả về object rỗng
        playerConfigs,
        updateSingleConfig,
        updatePlayerConfig,
        updateMultiplePlayersConfig,
    };
};

export default usePlayerConfig;
